import DesktopSearchWrapper from "./components/DesktopSearchWrapper";
import MobileSearchWrapper from "./components/MobileSearchWrapper";
import React from "react";
export default function App() {
    return (<>
      <div className="lg:hidden">
        <MobileSearchWrapper />
      </div>
      <div className="hidden lg:block">
        <DesktopSearchWrapper />
      </div>
    </>);
}
